import { render } from "./CalendarizeHolidays.vue?vue&type=template&id=faff4168&scoped=true"
import script from "./CalendarizeHolidays.vue?vue&type=script&lang=js"
export * from "./CalendarizeHolidays.vue?vue&type=script&lang=js"

import "./CalendarizeHolidays.vue?vue&type=style&index=0&id=faff4168&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faff4168"]])

export default __exports__